export const GridEventosPadrao = {
    fontWeight: 400,
    padding: '4px'
}

export const GridInfoEventosSx = {
    ...GridEventosPadrao,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
}

export const GridInfoEventosValueSx = {
    fontWeight: 700,
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
}

export const InfoEventoTextAreaSx = {
    width: '100%',
    height: 'calc(100% - 15px)',
    resize: 'none',
    borderRadius: '5px',
    padding: 0,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '13px',
    backgroundColor: 'white'
}

export const GridLogEventosSx = {
    ...GridEventosPadrao,
    // border: '1px solid orange',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
}

export const GridBtnLogEventoSx = {
    // border: '1px solid black',
    display: 'flex',
    justifyContent: 'flex-start',
    gap: 0.8
}

export const BtnLogEventoSx = {
    width: '20px',
    height: '20px',
    borderRadius: '5px',
    backgroundColor: '#D9D9D9',
    color: 'black',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
}

export const LogEventoTextAreaSx = {
    ...InfoEventoTextAreaSx,
    height: '100%'
}

export const GridNumeroVersaoSx = {
    width: '100%',
    height: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '11px',
    // fontFamily: 'Segoe UI',
    textShadow: '1px 1px black'
    // border: '1px solid red'
}
